// Orientation tour — the shell walkthrough every new SME sees first. All steps
// render on /home and highlight the shared chrome (rail, search, About, Ask
// PRIME, help), so every authenticated persona keeps all steps under RBAC.
import { ANCHORS } from '../../features/tours/tourAnchors.js';

export const orientation = {
  id: 'orientation',
  title: 'Get oriented',
  minutes: 2,
  steps: [
    {
      id: 'orient-attention',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.homeAttention,
      title: 'Home is what needs you',
      body: 'Home opens with your attention queue: the prioritized list of items waiting on you. Start each day here to see what changed and where to act first.',
    },
    {
      id: 'orient-nav-rail',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.navRail,
      title: 'Move between areas',
      body: 'The left rail is how you move between areas of the system. Pick an area to open it; the rail stays with you everywhere you go.',
    },
    {
      id: 'orient-nav-toggle',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.navViewToggle,
      title: 'Essentials, then everything',
      body: 'The rail can show just the essentials or every area at once. Start with the essentials and switch to the fuller view once they feel familiar.',
      fallbackBody: 'A view switch in the left rail toggles between the essential areas and the full list.',
    },
    {
      id: 'orient-search',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.topbarSearch,
      title: 'Find anything fast',
      body: 'Search across portfolios, programs, projects, and briefing products from the top bar. Type a name or an ID to jump straight to the record.',
    },
    {
      id: 'orient-about',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.aboutThisPage,
      title: 'What is this page?',
      body: 'Every page has an About button that explains what the page is for and who uses it. Open it whenever a screen is new to you.',
      fallbackBody: 'An About button on each page explains what the page is for and who uses it.',
    },
    {
      id: 'orient-copilot',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.copilotLauncher,
      title: 'Ask PRIME anything',
      body: 'Ask PRIME is your built-in assistant. Open it to ask a question in plain language and get an answer grounded in your live records.',
      fallbackBody: 'The Ask PRIME assistant opens from the corner of the screen when you need a plain-language answer.',
    },
    {
      id: 'orient-help',
      route: '/home',
      routeKey: '/home',
      anchor: ANCHORS.helpMenu,
      title: 'Help is always here',
      body: 'The help menu gathers the glossary, the capability map, and these tours in one place. Come back here any time you want a refresher.',
      fallbackBody: 'A help menu in the top bar collects the glossary, the capability map, and these guided tours.',
    },
  ],
  closingNarrative:
    'That is the whole frame: home for what needs you, the rail to move, search to find, and Ask PRIME when you are stuck. You are ready to explore.',
};
